/* eslint-disable camelcase */
import { useMemo } from 'react';

export const useInitialValues = ({
  currentUser = {},
  customizable_attributes = [],
}) =>
  useMemo(
    () => ({
      firstname: currentUser.firstname || '',
      lastname: currentUser.lastname || '',
      email: currentUser.email || '',
      postal_address_type: 'personal',
      billing_address_attributes: {
        address_1: '',
        address_2: '',
        address_3: '',
        city: '',
        country: '',
        postal_code: '',
        state: '',
        ...currentUser.postal_address?.personal,
      },
      shipping_address_attributes: {
        same_as_billing: true,
      },
      ...customizable_attributes.filter(Boolean).reduce(
        (attributes, { name, value = '' }) => ({
          ...attributes,
          [name]: value ?? '',
        }),
        {},
      ),
    }),
    [currentUser, customizable_attributes],
  );
